import { Group, Stack, Title } from "@mantine/core"
import { IconRefresh } from "@tabler/icons-react"
import { Button, Select } from "@tfg/ui"
import { useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import {
  FindIngestionsQueryParams,
  IngestionStatusEnumKey,
  ingestionStatusEnum,
} from "~/gen/api"
import { IngestionList } from "~/pages/Admin/Ingestion/ProductImport/IngestionList"
import { useFindIngestionsQuery } from "~/pages/Admin/Ingestion/ProductImport/hooks/useFindIngestionsQuery"
import { useProductImportContext } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportContext"

export function isIngestionStatusType(
  status: string | null
): status is IngestionStatusEnumKey {
  if (status === null) return false
  return Object.values(ingestionStatusEnum).includes(
    status as IngestionStatusEnumKey
  )
}

export function IngestionListWrapper() {
  const [filters, setFilters] = useState<FindIngestionsQueryParams>({
    sorts: {
      createdAt: {
        value: "desc",
        rank: 1,
      },
    },
    filters: {},
  })
  const ingestionListQuery = useFindIngestionsQuery(filters)
  const { owners } = useProductImportContext()

  return (
    <Stack px="var(--tfg-layout-padding-x)" gap="xs">
      <Title order={3} py="sm">
        Ingestions
      </Title>
      <DataFetchWrapper query={ingestionListQuery}>
        {({ data, refetch }) => (
          <>
            <Group mb="sm">
              <Select
                data={Object.values(ingestionStatusEnum)}
                placeholder="Select status"
                size="xs"
                onChange={(value: string | null) => {
                  const status = isIngestionStatusType(value)
                    ? value
                    : undefined
                  setFilters({ ...filters, status })
                }}
              />
              <Select
                data={owners}
                size="xs"
                placeholder="Select owner"
                onChange={(value) => {
                  setFilters({ ...filters, emailLauncher: value ?? undefined })
                }}
              />
              <Button onClick={() => refetch()}>
                <IconRefresh />
              </Button>
            </Group>
            <IngestionList ingestions={data.data} />
          </>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
